import React from 'react'
import { Text } from '../../styles/Components'
import { useField, useFormState } from 'react-final-form'
import ArrowDownBlack from '../../../public/images/arrow-down-black.svg'
import styled from '@emotion/styled'
import { gsColors } from '../../styles/Variables'
import Image from 'next/image'
import { mq } from '../../helpers'

const SelectContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid
    ${({ hasError }) => (!hasError ? '#000' : gsColors.errorRed)};

  select {
    appearance: none;
    flex: 1;
    font-family: Euclid;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.36px;
    border: none;
    width: 100%;
    height: 54px;
    cursor: pointer;
    background: transparent;
    color: ${({ hasValue, hasError }) =>
    hasError
      ? gsColors.errorRed
      : hasValue
        ? '#000'
        : gsColors.meredithGrey};

    ${mq('max', '768px')} {
      font-size: 16px;
      padding-left: 0;
    }
  }
`

const SelectField = React.forwardRef(({ name, placeholder, options }, ref) => {
  const { input, meta } = useField(name)
  const hasValue = input.value && input.value !== ''
  const { submitFailed } = useFormState({ subscription: { submitFailed: true } })

  const handleSelect = (e) => {
    input.onFocus()
    input.onChange(e.target.value)

    setTimeout(() => {
      input.onBlur()
    }, 0)
  }

  const hasError = submitFailed && meta?.error

  return (
    <div ref={ref} style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <SelectContainer hasError={hasError} hasValue={hasValue}>
        <select
          aria-label="selected-time"
          value={input.value}
          onChange={handleSelect}
        >
          <option value="" disabled hidden>
            {placeholder}
          </option>
          {options.map((opt, i) =>
            typeof opt === 'object' ? (
              <option key={i} value={opt.value}>
                {opt.name}
              </option>
            ) : (
              <option key={i} value={opt}>
                {opt}
              </option>
            ),
          )}
        </select>
        <Image src={ArrowDownBlack} alt="" aria-hidden="true" color="#000" />
      </SelectContainer>
      {!!hasError && (
        <Text color={gsColors.errorRed} margin="6px 0 0 0">
          {meta?.error || 'Required'}
        </Text>
      )}
    </div>
  )
})

export default SelectField
